import {
  VALIDATION_RULE,
  APEX_TRIGGER,
  APEX_CLASS,
  APPROVAL_PROCESS,
  WORKFLOW_RULE,
  PROCESS_BUILDER_FLOW,
  LAYOUT,
  FLOW,
  RECORD_TYPE,
  FIELD,
} from '@server/parser';
import { DataTableId } from '../../components/common/table/utils';
import {
  ROLLUP,
  SWEEP_ASSIGNMENT,
  SWEEP_ALERT,
  SWEEP_AUTOMATION,
  SWEEP_SCHEDULED_ASSIGNMENT,
  SWEEP_DEDUPE,
  SWEEP_MATCHING,
} from '../../components/parser/ConfigurationItemTypes';

export enum DocumentationTabTypes {
  RECORD_TYPES = 'Record Types',
  SF_AUTOMATIONS = 'Salesforce Automations',
  APEX = 'Apex',
  FIELDS = 'Fields',
  VALIDATION_RULES = 'Validation Rules',
  SWEEP_AUTOMATIONS = 'Sweep Automations',
  PLAYBOOK_ALERTS = 'Alerts',
  MATCHING_DEDUPE = 'Dedupe & Matching',
  ASSIGNMENTS = 'Assignments',
  SCHEDULED_ASSIGNMENTS = 'Scheduled Assignments',
  CARDS_LIST = 'elements', //main view
  LAYOUTS = 'Layouts',
  RELATED_OBJECTS = 'Related objects',
  OTHER = 'Other',
}

export const SWEEP_ELEMENTS_TAB_TYPES = [
  DocumentationTabTypes.MATCHING_DEDUPE,
  DocumentationTabTypes.PLAYBOOK_ALERTS,
  DocumentationTabTypes.SWEEP_AUTOMATIONS,
  DocumentationTabTypes.SCHEDULED_ASSIGNMENTS,
  DocumentationTabTypes.ASSIGNMENTS,
];

export const ConfigurationTypeToDocumentationTabType = {
  [VALIDATION_RULE]: DocumentationTabTypes.VALIDATION_RULES,
  [APEX_TRIGGER]: DocumentationTabTypes.APEX,
  [APEX_CLASS]: DocumentationTabTypes.APEX,
  [APPROVAL_PROCESS]: DocumentationTabTypes.SF_AUTOMATIONS,
  [WORKFLOW_RULE]: DocumentationTabTypes.SF_AUTOMATIONS,
  [PROCESS_BUILDER_FLOW]: DocumentationTabTypes.SF_AUTOMATIONS,
  [LAYOUT]: DocumentationTabTypes.LAYOUTS,
  [FLOW]: DocumentationTabTypes.SF_AUTOMATIONS,
  [RECORD_TYPE]: DocumentationTabTypes.RECORD_TYPES,
  [FIELD]: DocumentationTabTypes.FIELDS,
  [SWEEP_ASSIGNMENT]: DocumentationTabTypes.ASSIGNMENTS,
  [SWEEP_ALERT]: DocumentationTabTypes.PLAYBOOK_ALERTS,
  [SWEEP_AUTOMATION]: DocumentationTabTypes.SWEEP_AUTOMATIONS,
  [SWEEP_SCHEDULED_ASSIGNMENT]: DocumentationTabTypes.SCHEDULED_ASSIGNMENTS,
  [SWEEP_DEDUPE]: DocumentationTabTypes.MATCHING_DEDUPE,
  [SWEEP_MATCHING]: DocumentationTabTypes.MATCHING_DEDUPE,
  [ROLLUP]: DocumentationTabTypes.FIELDS,
};

export const DocumentationTabToTableId: { [key in DocumentationTabTypes]: DataTableId } = {
  [DocumentationTabTypes.FIELDS]: DataTableId.DocumentationExpandedFieldsTable,
  [DocumentationTabTypes.RECORD_TYPES]: DataTableId.DocumentationExpandedRecordTypesTable,
  [DocumentationTabTypes.SF_AUTOMATIONS]: DataTableId.DocumentationExpandedAutomationsTable,
  [DocumentationTabTypes.APEX]: DataTableId.DocumentationExpandedApexTable,
  [DocumentationTabTypes.VALIDATION_RULES]: DataTableId.DocumentationExpandedValidationRulesTable,
  [DocumentationTabTypes.SWEEP_AUTOMATIONS]: DataTableId.DocumentationExpandedSweepAutomationsTable,
  [DocumentationTabTypes.PLAYBOOK_ALERTS]: DataTableId.DocumentationExpandedAlertsTable,
  [DocumentationTabTypes.MATCHING_DEDUPE]: DataTableId.DocumentationExpandedDedupeTable,
  [DocumentationTabTypes.ASSIGNMENTS]: DataTableId.DocumentationExpandedAssignmentsTable,
  [DocumentationTabTypes.SCHEDULED_ASSIGNMENTS]:
    DataTableId.DocumentationExpandedScheduledAssignmentsTable,
  [DocumentationTabTypes.LAYOUTS]: DataTableId.DocumentationExpandedLayoutsTable,
  [DocumentationTabTypes.RELATED_OBJECTS]: DataTableId.DocumentationExpandedRelatedObjectsTable,
  [DocumentationTabTypes.CARDS_LIST]: DataTableId.DocumentationExpandedCardsListTable,
  [DocumentationTabTypes.OTHER]: DataTableId.DocumentationExpandedOtherTable,
};
